<div>
    <div class="">
        <div [innerHTML]="safeHTML(optinForm.html_content)"></div>
    </div>
</div>